import React from "react";
import Experience from "../../pages/Experience/Experience";
import CareerSection from "../Section/CareerSection";

const Main = () => {
  return (
    <>
      <Experience />
      <CareerSection />
    </>
  );
};

export default Main;
